// Unified auth hook that works with both Auth0 and Local authentication
import { useAuth0 as useAuth0Original } from '@auth0/auth0-react';
import { useLocalAuth } from '../components/LocalAuthProvider';

// Check if we're in test/local auth mode
const isTestEnvironment = process.env.REACT_APP_AUTH_MODE === 'local' ||
                          process.env.REACT_APP_ENVIRONMENT === 'test';

// Export a unified useAuth hook
export const useAuth = () => {
    if (isTestEnvironment) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useLocalAuth();
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useAuth0Original();
};

// Also export as useAuth0 for compatibility
export const useAuth0 = useAuth;

export default useAuth;
